import { render } from "./ShadowBlock.vue?vue&type=template&id=54042801"
const script = {}

import "./ShadowBlock.vue?vue&type=style&index=0&id=54042801&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__